import Gutter from './Gutter'
import { connect } from 'react-redux'
import * as orderSelectors from '../../../selectors/order'

const mapStateToProps = state => ({
  orderSummary: orderSelectors.getOrderSummary(state),
  isLoading: orderSelectors.orderSummaryLoading(state)
})

export default connect(mapStateToProps)(Gutter)



// WEBPACK FOOTER //
// ./src/modules/Checkout/Gutter/index.js